module.exports = __webpack_public_path__ + "static/media/03-benefit-marmomac-academy.519ddbed.jpg";